import { Component } from 'react'
import styles from '~/styles/utils.userSettings.module.css'

export default class UserSettings extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'common' ],
		}
	}

	constructor(props) {
		super(props)
		this.state = {
			isWaiting: false,
			isError: false,
		}
	}

	public render(): JSX.Element {
		return (
			<Button
				type={this.props.type}
				id={this.props.id}
				saveButton={this.props.saveButton}
				setSaveButton={this.props.setSaveButton}
				onClick={this._add.bind(this)}
				isWaiting={this.state.isWaiting}
				isError={this.state.isError}
				isDone={this.state.isDone}
				t={this.props.t}
			/>
		)
	}

	public componentDidUpdate(prevProps, prevState) {
		if (prevProps.saveButton && this.props.saveButton) {
			const differentId = (prevProps.saveButton.id !== this.props.saveButton.id)
			const differentValue = (prevProps.saveButton.value !== this.props.saveButton.value)
			if (differentId || differentValue) {
				if (this.state.isError) {
					this.setState({ isError: false })
				}
			}
		}
	}

	private _add(object): void {
		if (object) {
			let data = JSON.stringify(object)
			if (data !== this._previosData) {
				this.setState({
					isWaiting: true,
					isDone: false,
				})
				if (this.st)	clearTimeout(this.st)
				this.st = setTimeout(() => {
					this.setState({ isWaiting: false })
				}, 10000)
				this._previosData = data
				const on200 = () => {
					clearTimeout(this.st)
					this.setState({ isWaiting: false })
				}
				saveUserSettings(data, on200.bind(this)).then(json => {
					if (json.result) {
						this.setState({ isDone: true })
						if (this.props.onSave) {
							this.props.onSave()
						}
						this.st = setTimeout(() => {
							if (this.props.setSaveButton) {
								this.props.setSaveButton('')
							}
							this.setState({ isDone: false })
						}, 2000)
					}
					this.setState({ isError: !json.result })
				}).catch(error => {
					this.setState({ isError: true })
				})
			}
		}
	}
}

export const saveUserSettings = (json, on200) => {
	return fetch('/api/v1/onUserSettings', {
		headers: { 'Content-Type': 'application/json' },
		method: 'POST',
		body: json,
	}).then(response => {
		if (response.status === 200 && on200) {
			on200()
		}
		return response.json()
	})
}

class Button extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'common' ],
		}
	}
	
	constructor(props) {
		super(props)
	}

	public render(): JSX.Element {
		if ((this.props.saveButton?.id === this.props.id) || !this.props.saveButton) {
			return this._getRangeApply(!!this.props.saveButton)
		} else {
			return null
		}
	}

	private _getRangeApply(isShown): JSX.Element {
		let label = (this.props.isError ? 'Not saved!' : 'Save')
		let className = (this.props.isError || this.props.isDone ? styles.error : styles.button) 
		if (!isShown || this.props.isWaiting) {
			className += ' ' + styles.disabled
			if (this.props.isWaiting) {
				label = 'Saving'
			}
		} else if (this.props.isDone) {
			className += ' ' + styles.isDone
			label = 'Saved'
		}
		return (
			<div
				className={styles.main}
			>
				<div
					className={className}
					onClick={this.props.onClick.bind(this, this.props.saveButton)}
				>
					{this.props.t(label)}
				</div>
			</div>
		)
	}
}